import Head from 'next/head';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { DynamicPlayer } from './DynamicPlayer';

export const HeaderCard = ({ content }: Content.HeaderCard) => {
	const { kicker, teaser, heading, image, imageAltText, link, video } = content ?? {};

	return (
		<>
			<Head>
				<meta name="search-kicker" content={kicker} />
			</Head>
			<UI_HeaderCard
				heading={heading}
				kicker={kicker}
				teaser={teaser}
				image={image && { url: image?.url, focalPoint: { left: image?.focalPoint?.left, top: image?.focalPoint?.top } }}
				imageAltText={imageAltText}
				link={link}
				player={video && <DynamicPlayer url={video.url} loop={true} />}
			/>
		</>
	);
};
